export default {
  install: (Vue) => {
    // eslint-disable-next-line
    Vue.prototype.$wx = wx
  }
}
